import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Modal, Collapse, Spin, Button as AntdButton } from 'antd';
import { CloseOutlined, BookOutlined } from '@ant-design/icons';
import './styles.scss';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';

const { Panel } = Collapse;

const ExplanationModal = ({
  open,
  onClose,
  item
}) => {
  const { t } = useTranslation();
  const [list, setList] = useState([])
  const [isLoading, setLoading] = useState(false)

  const fetchExplanationList = async () => {
    setLoading(true)
    const res = await fetchData(restAPIs.getExplantionsList(item?.lineId));
    setList(res)
    setLoading(false);
  }

  useEffect(() => {
    if (item) {
      fetchExplanationList();
    }
    // eslint-disable-next-line
  }, [item?.lineId]);

   const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      footer={null}
      closable={false}
      className="__common_model_class"
    >
      <div className="__common_model_content">
        <div className="__common_model_content_head" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom:20 }}>
          <h3 style={{ margin: 0 }}>{t('explanations')}</h3>
          <AntdButton
            type="text"
            icon={<CloseOutlined />}
            onClick={handleClose}
            style={{ fontSize: 18 }}
          />
        </div>
        <div className="text-center mb-4">
          <p style={{ margin: 0, fontWeight: 'bold', fontSize: 20 }}>{item?.line1}</p>
          <p style={{ margin: 0, fontWeight: 'bold', fontSize: 20 }}>{item?.line2}</p>
        </div>
        {isLoading ? (
          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <Spin />
          </div>
        ) : (
          <Collapse accordion>
            {list && list?.map((item, idx) => (
              <Panel
                header={
                  <span>
                    <BookOutlined style={{ marginLeft: 8 }} />
                    <b style={{ margin: '0 10px' }}>{item?.book?.bookWebTitle}</b>
                  </span>
                }
                key={idx}
              >
                <h4 style={{ fontSize: 18, lineHeight: 1, marginBottom: 10, color: '#795548' }}>
                  {item?.book?.bookTitle}
                </h4>
                <p style={{ fontSize: 17, lineHeight: 1.7, color: '#967c1c' }}>
                  {item?.explanation}
                </p>
                <p style={{ marginBottom: 5, marginTop:10 }}>
                  <span style={{ color: '#c9a212' }}>{t('explainer') || 'Explainer'}:</span>{' '}
                  {item?.book?.explainer?.explainerFullName} ({item?.book?.explainer?.explainerNickName})
                </p>
                <p style={{ marginBottom: 5 }}>
                  <span style={{ color: '#c9a212' }}>{t('publisher') || 'Publisher'}: </span>
                  {item?.book?.publisher}
                </p>
                <p style={{ marginBottom: 5 }}>
                  <span style={{ color: '#c9a212' }}>{t('country') || 'Country'}:</span> {item?.book?.country}
                </p>
                <p style={{ marginBottom: 5 }}>
                  <span style={{ color: '#c9a212' }}>{t('city') || 'City'}: </span>{item?.book?.city}
                </p>
                <p style={{ marginBottom: 5 }}>
                  <span style={{ color: '#c9a212' }}>{t('publishingDate') || 'Publishing Date'}:</span> {item?.book?.explanation}
                </p>
              </Panel>
            ))}
          </Collapse>
        )}
        <div className="d-flex mt-4 pb-3" style={{ justifyContent: 'flex-end' }}>
          <AntdButton className="closeBtn" onClick={handleClose}>
            {t('cancel')}
          </AntdButton>
        </div>
      </div>
    </Modal>
  );
};

ExplanationModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  item: PropTypes.any
};

export default ExplanationModal;
